module.exports = __webpack_public_path__ + "static/media/logo.47fb9dae.svg";